import { Api } from './BaseApi'
import { IClient } from '../../types/Client/IClient';
import { IClientType } from '../../types/Client/IClientType';
import { IOffice } from '../../types/Client/IOffice';

const ClientApi = Api.injectEndpoints({
    endpoints: (build) => ({
        getClient: build.query<IClient, number>({
            query: (Id) => `Client/${Id}`,
            providesTags: ["GetClient"],
        }),
        getMyClients: build.query<IClient[], void>({
            query: (Id) => `Client/My`,
            providesTags: ["GetMyClient"],
        }),
        getClientList: build.query<IClient[], number | undefined>({
            query: (companyTypeId) => {
                if (companyTypeId)
                    return `Client/ByType/${companyTypeId}`;

                return `Client`
            },
            providesTags: ["ClientList"],
        }),
        getClientTypes: build.query<IClientType[], void>({
            query: () => `Client/Type/`,
            providesTags: ["GetClientTypes"],
        }),
        getOffice: build.query<IOffice, number>({
            query: (Id) => `Office/${Id}`,
            providesTags: ["GetOffice"],
        }),
        getClientOffices: build.query<IOffice[], number>({
            query: (Id) => `Client/${Id}/Office`,
            providesTags: ["GetOfficeList"],
        })
    }),
    overrideExisting: false,
})

export { ClientApi };